import { ADD_OPENED_WINDOW, REMOVE_OPENED_WINDOW, REMOVE_OPENED_WINDOWS, SET_ONETIME, SET_REGULAR } from '../constants';

const windowsReducer = (state, action) => {
  const defaultState = {
    openedWindows: {},
    newWindow: '',
    onetime: window.config.onetime_counters,
    regular: window.config.regular_counters,
  };

  if (!state) {
    state = defaultState;
  }

  const newOpenedWindows = { ...state.openedWindows };

  switch (action.type) {
    case ADD_OPENED_WINDOW:
      newOpenedWindows[action.data.id] = action.data;
      return {
        ...state,
        openedWindows: newOpenedWindows,
        newWindow: action.data.id,
      };
    case REMOVE_OPENED_WINDOW:
      delete newOpenedWindows[action.id];
      return {
        ...state,
        newWindow: '',
        openedWindows: newOpenedWindows,
      };
    case REMOVE_OPENED_WINDOWS:
      return {
        ...state,
        newWindow: '',
        openedWindows: {},
      };
    case SET_ONETIME:
      return {
        ...state,
        onetime: action.data,
      };
    case SET_REGULAR:
      return {
        ...state,
        regular: action.data,
      };
    default:
      return state;
  }
};

export default windowsReducer;
